import React, { useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';

const Signature = ({ onClear }) => {
  const signatureRef = useRef(null);
  const [isCleared, setIsCleared] = useState(false);

  // Clear the signature canvas
  const handleClear = () => {
    signatureRef.current.clear(); // Clears the canvas
    localStorage.removeItem("signature");
    setIsCleared(true);
    onClear(true); // Notify parent that the signature has been cleared
  };

  // Get the signature image (base64) from the canvas
  const saveSignature = () => {
    localStorage.setItem("signature", signatureRef.current.getTrimmedCanvas().toDataURL('image/png'))
    
  };

  return (
    <div style={{border: '2px solid' , width: 310 , padding: '2px', margin: 2}}>
      <SignatureCanvas
        ref={signatureRef}
        penColor="black"
        canvasProps={{ width: 300, height: 200, className: 'signature-canvas' }}
      />
      <button type="button"  onClick={handleClear}>Clear Signature</button>
      <button type="button"  onClick={saveSignature}>Save Signature</button>
    </div>
  );
};


export default Signature;